import sharedModule from '../../shared.module';

export default sharedModule.component('asLoadingMask', {
    template: require('./asLoadingMask.component.html'),
    styles: require('./asLoadingMask.component.css'),
    controller(asLoadingMask) {
        this.asLoadingMask = asLoadingMask;
    }
});



// WEBPACK FOOTER //
// ./modules/shared/components/asLoadingMask/asLoadingMask.component.js